<template>
  <div ref="popupLayer" class="layer-light">
    <ProfileMainView v-if="viewType === 'main'" />
    <ProfileWithdrawView v-if="viewType === 'withdraw'" />
    <ProfileImageView v-if="viewType === 'image'" />
    <ProfileWatvIntegartionView v-if="viewType === 'integration'" @on-integration-success="onIntegrationSuccess" />
  </div>
</template>

<script setup lang="ts">
import ProfileMainView from '~/components/Profile/ProfileMainView.vue'
import ProfileWithdrawView from '~/components/Profile/ProfileWithdrawView.vue'

const popupLayer = ref<HTMLDivElement>()
const { viewType, changeViewType } = useProfile()

const bodyClass = ref('')
useHead({
  bodyAttrs: {
    class: bodyClass,
  },
})

function onIntegrationSuccess() {
  location.reload()
}

useEventListener('resize', () => {
  if (window.innerWidth < 768) {
    bodyClass.value = 'lock'
  }
  else {
    bodyClass.value = ''
  }
})

onUnmounted(() => {
  changeViewType('main')
})
</script>

<style>
@import '~/assets/css/login.css';
@import '~/assets/css/setting.css';
</style>
